import { Component, ViewChild } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { NgxAimAdminEditFflComponent } from './edit-ffl/ngx-aim-admin-edit-ffl.component';
import { NgxAimAdminPrimengModule } from '../../ngx-aim-admin.primeng.module';
import { AppLazyLoadEvent } from '../../../../models';
import { MatchModesPrime } from '../../../../enums';
import { NgxAimAdminFflService } from './ngx-aim-admin-admin-ffl.service';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
  selector: 'ngx-aim-admin-ffl',
  standalone: true,
  imports: [NgxAimAdminPrimengModule, NgClass, AsyncPipe],
  templateUrl: './ngx-aim-admin-ffl.component.html',
  styleUrls: ['./ngx-aim-admin-ffl.component.scss', '../../admin.scss'],
  providers: [DialogService],
})
export class NgxAimAdminFflComponent {
  @ViewChild('dt') table: Table | undefined;
  data$ = this.entityService.data$;
  isLoading$ = this.entityService.isLoading$;
  dataCount$ = this.entityService.dataCount$;
  lastLazyLoadEvent: AppLazyLoadEvent = {
    globalFilterFields: [],
    filters: {}
  };
  selectedOptions: string[] = [];

  constructor(
    private entityService: NgxAimAdminFflService,
    private dialogService: DialogService,
  ) {}

  onLazyLoad($event: TableLazyLoadEvent) {
    this.lastLazyLoadEvent = $event;
    const lazyLoadEvent: AppLazyLoadEvent = Object.assign({
      withDeleted: this.selectedOptions.includes('withDeleted'),
      globalFilterFields: this.table?.globalFilterFields || [],
    }, $event);

    this.entityService.onFilterEvent(lazyLoadEvent);
  }

  applyFilterGlobal($event: Event) {
    this.table?.filterGlobal(($event.target as HTMLInputElement).value, MatchModesPrime.CONTAINS);
  }

  onNewClick() {
    this.openEntity();
  }

  openEntity(entityId?: number) {
    console.log(entityId);
    const dialog = this.dialogService.open(NgxAimAdminEditFflComponent, {
      data: entityId,
      header: 'FFL',
      width: '700px',
      contentStyle: { "max-height": "580px", "overflow": "auto" },
      dismissableMask: true
    });
    dialog.onClose.subscribe(() => {
      this.onLazyLoad(this.lastLazyLoadEvent);
    });
  }
}
